"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

exports.useDialogTransition = function (originalRef, targetRef, active) {
  var _a = react_1.useState(false),
      transitioning = _a[0],
      setTransitioning = _a[1];

  var _b = react_1.useState(undefined),
      style = _b[0],
      setStyle = _b[1]; // TODO add refs to effect inputs?


  react_1.useLayoutEffect(function () {
    if (!targetRef.current) {
      setStyle(undefined);
    } else if (originalRef.current && !transitioning && active) {
      var rect = originalRef.current.getBoundingClientRect();
      var rect2 = targetRef.current.getBoundingClientRect();
      setStyle({
        transformOrigin: 'top left',
        transform: "\n          translate3d(" + (rect.x - rect2.x) + "px, " + (rect.y - rect2.y) + "px, 0)\n          scale(" + rect.width / rect2.width + ", " + rect.height / rect2.height + ")\n        "
      });
      setTransitioning(true);
    }
  }, [active]);

  if (!transitioning && !active && style) {
    setTransitioning(true);
    transitioning = true;
  }

  react_1.useEffect(function () {
    if (transitioning && active) {
      setStyle({
        transformOrigin: 'top left',
        transition: 'all 250ms linear',
        transform: "translate3d(0, 0, 0) scale(1, 1)"
      });
    } else if (transitioning && !active && originalRef.current && targetRef.current) {
      var rect = originalRef.current.getBoundingClientRect();
      var rect2 = targetRef.current.getBoundingClientRect();
      setStyle({
        transformOrigin: 'top left',
        transition: 'all 250ms linear',
        //opacity: 0,
        transform: "\n          translate3d(" + (rect.x - rect2.x) + "px, " + (rect.y - rect2.y) + "px, 0)\n          scale(" + rect.width / rect2.width + ", " + rect.height / rect2.height + ")\n        "
      });
    }

    if (targetRef.current) {
      var el_1 = targetRef.current;

      var listener_1 = function listener_1() {
        setStyle(active ? {} : undefined);
        setTransitioning(false);
        el_1.removeEventListener('transitionend', listener_1);
        el_1.removeEventListener('transitioncancel', listener_1);
      };

      el_1.addEventListener('transitionend', listener_1);
      el_1.addEventListener('transitioncancel', listener_1);
      return function () {
        el_1.removeEventListener('transitioncancel', listener_1);
        el_1.removeEventListener('transitionend', listener_1);
      };
    }
  }, [active, transitioning]);
  return {
    style: style,
    showDialog: active || transitioning
  };
};